import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import "./style.scss";
import {getRoutes, setIndexPath} from "IncompleteInfoV2/routes";
import {IToastDetails, IUserStatus} from "StateInterface";
import {getLatestApplicationStatus} from "profile/api";
import {setLatestApplicationStatus} from "profile/actions";
import Loading from "components/loading";
import {hideToast, setIncompleteInfoScreens} from "IncompleteInfoV2/actions";
import {getIncompleteInfoScreens, MessageType} from "IncompleteInfoV2/utils";
import {IScreens} from "IncompleteInfoV2/interface";
import ErrorCard from "IncompleteInfoV2/errorCard";
import {ApplicationStatus} from "profile/enums";
import {AndroidApis} from "app";
import Toast from "components/toast";
import {whatsAppLink} from "utils/variables";
import {websiteUrl} from "config";
import {ENV} from "Dashboard/utils";
import {exitWebview} from "utils/android";
import {ILatestStatus} from "profile/interface";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    userStatus: IUserStatus;
    loanApplicationInfo: ILatestStatus;
    screens: IScreens;
    toastDetails: IToastDetails;
    utm_source?: string;
}

const IncompleteInfV2 = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [message, updateMessage] = useState<{type: string, status: string}>(null);
    const fetchProfile = (completed: boolean) => {
        setLoading(true);
        getLatestApplicationStatus().then((response) => {
            setLoading(false);
            props.dispatch(setLatestApplicationStatus(response));
            statusMessageUpdate(response, false);
        }).catch((err) => {
            setLoading(false);
        });
    };
    const statusMessageUpdate = (loanApplicationInfo: ILatestStatus, completed: boolean) => {
        const status = loanApplicationInfo && loanApplicationInfo.status;
        if (status === ApplicationStatus.INITIATED) {
            updateMessage({type: MessageType.SUCCESS, status});
            if (!props.isAndroid) {
                window.location.href =`${websiteUrl}/dashboard/`;
            } else {
                exitWebview();
            }
        }
        if ((completed && status === ApplicationStatus.INCOMPLETE_INFO) || (!props.screens && status === ApplicationStatus.INCOMPLETE_INFO)) {
            updateMessage({type: MessageType.ERROR, status});
        }
    };
    useEffect(() => {
        if (props.isAndroid) {
            AndroidApis.clearWebStack();
            AndroidApis.toolBarConfig({
                visibility: true,
                title: "Incomplete-info",
                whatsAppLink,
                menuItems: {
                    action_whatsApp: true,
                    action_chat: false,
                },
            });
        }
        setIndexPath(props.match.url);
        fetchProfile(false);
    }, []);
    useEffect(() => {
        if (props.loanApplicationInfo &&
            props.loanApplicationInfo.subStatuses &&
            props.loanApplicationInfo.subStatuses.length) {
            const screens = getIncompleteInfoScreens(props.loanApplicationInfo.subStatuses);
            if (Object.keys(screens).length) {
                props.dispatch(setIncompleteInfoScreens(screens));
            }
        }
    }, [props.loanApplicationInfo]);
    useEffect(() => {
        if (props.screens && Object.keys(props.screens).length === 0) {
            fetchProfile(true);
        }
    }, [props.screens]);
    const handleHideToast = () => {
        props.dispatch(hideToast());
    };
    return (
        <React.Fragment>
            <Loading active={loading} msg="Please wait while loading.."/>
            {props.toastDetails && <Toast hideToast={handleHideToast} toastDetails={props.toastDetails}/>}
           {
               props.loanApplicationInfo && props.screens &&
               Object.keys(props.screens).length ?
               getRoutes(props.match.path) :
                   message ? <ErrorCard utmSource={props.utm_source} message={message}/> : null
           }
        </React.Fragment>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        userStatus: state.profileInfo.userStatus,
        loanApplicationInfo: state?.profileInfo?.latestStatus,
        screens: state.incompleteInfoV2.screens,
        toastDetails: state.incompleteInfoV2.toastDetails,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(IncompleteInfV2);
